import { render, staticRenderFns } from "./GroupGame.vue?vue&type=template&id=d2483566&"
import script from "./GroupGame.vue?vue&type=script&lang=js&"
export * from "./GroupGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports